module.exports = __webpack_public_path__ + "static/img/ChronoPress_OLD_HIghRes_white.fda8f74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ChronoPress_OLD_HIghRes_white.png
// module id = YXAg
// module chunks = 0